import { Toaster } from "sonner";
import { useI18nSafe } from "@/lib/i18n/i18n-context";

/**
 * Direction-aware toaster — reads current language from I18nProvider
 * to set the correct dir (rtl/ltr) for toast notifications.
 */
export function DashboardToaster() {
  const { language } = useI18nSafe();
  const dir = language === "ar" ? "rtl" : "ltr";

  return (
    <Toaster
      position="top-center"
      dir={dir}
      richColors
      toastOptions={{
        style: {
          fontFamily: "'IBM Plex Sans Arabic', system-ui, sans-serif",
        },
      }}
    />
  );
}
